(function () {
    'use strict';

    angular.module("imApp").factory("salaryTypeLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTranslations: function (parms) {
                return $ihttp.post({
                    method: 485,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 486,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
